import React from 'react'
import { Container } from 'react-bootstrap'
import Slider from 'react-slick'
import a1 from './../assest/images/projectss/Ai/AI photos/Ramadan AI photo.jpg'
import a2 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/1.png'
import a3 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/2.png'
import a4 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/3-1.png'
import a5 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/4.png'
import a6 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/5.png'
import a7 from './../assest/images/projectss/Ai/AI photos/Visual Identity using Ai/6.png'
export const Ai = () => {
    const adata=[
    {
      cover:a1
    },
    {
        cover:a2
      },
      {
        cover:a3
      },
      {
        cover:a4
      },
      {
        cover:a5
      },
      {
        cover:a6
      },
      {
        cover:a7
      },
   
    ]
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };
  return (
<div className='certi ai'>
        <Container>
<div className='row'>
<Slider {...settings}>
    {adata.map((value,index)=>{
        return(
            <div className='' key={index}>
              
                <div className='img'>
                <img src={value.cover}/>
                </div>
                
            </div>
        )
    }) }
    </Slider>
</div>
        </Container>
    </div>
  )
}
